import { AutoRefreshTokenService, provideKeycloak, UserActivityService, withAutoRefreshToken } from 'keycloak-angular';

import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { environment } from '../environments/environment';
import { AuthenticationService } from './services/authentication/authentication.service';

// O SSR foi removido em 2026-08-28 e hoje só existe o bootstrap do browser,
// então esta guarda é sempre verdadeira. Ela fica como trava: se algum dia
// voltar um bootstrap de servidor compartilhando este appConfig, o
// keycloak.init() rodaria nos dois e o authorization code seria trocado duas
// vezes — a segunda troca falha com "invalid_grant: Code not valid", porque o
// code é de uso único. Custa nada e evita justamente esse retorno silencioso.
const isBrowser = typeof window !== 'undefined';

export const appConfig: ApplicationConfig = {
  providers: [
    // Sem initOptions o keycloak-angular nao registra o app initializer dele,
    // que segurava o bootstrap ate o keycloak.init() terminar. O init e nosso,
    // logo abaixo.
    provideKeycloak({
      config: {
        url: environment.keycloak.authority,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      providers: [AutoRefreshTokenService, UserActivityService]
    }),
    // Init só no browser, e por um caminho só.
    ...(isBrowser ? [
      provideAppInitializer(() => {
        // O mesmo passo que o initializer do keycloak-angular fazia antes do init.
        withAutoRefreshToken({
          onInactivityTimeout: 'logout',
          sessionTimeout: 900000
        }).configure();

        // Espera o init so na volta do login: a regra e o porque estao no
        // iniciarNoBootstrap(), onde tem spec.
        return inject(AuthenticationService).iniciarNoBootstrap({
          // keycloak-js loga cada passo no console com prefixo [KEYCLOAK].
          // Fica ligado em local e homolog (ambos com production: false) para
          // depurar init()/silent-SSO; em producao imprimiria todo o fluxo de
          // autenticacao no console do cliente.
          enableLogging: !environment.production,
          checkLoginIframe: false,
          onLoad: 'check-sso',
          redirectUri: environment.keycloak.redirectUri,
          silentCheckSsoRedirectUri:
            environment.baseUrl + '/assets/silent-check-sso.html',
          scope: 'openid',
        });
      })
    ] : []),
    provideAnimationsAsync()
  ]
};
